import { render, staticRenderFns } from "./SynastryMain.vue?vue&type=template&id=174914fc&"
import script from "./SynastryMain.vue?vue&type=script&lang=js&"
export * from "./SynastryMain.vue?vue&type=script&lang=js&"
import style0 from "./SynastryMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174914fc')) {
      api.createRecord('174914fc', component.options)
    } else {
      api.reload('174914fc', component.options)
    }
    module.hot.accept("./SynastryMain.vue?vue&type=template&id=174914fc&", function () {
      api.rerender('174914fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/雙人合盤/SynastryMain.vue"
export default component.exports